import { useEffect, useRef, useState } from 'react'
import LegalDocumentLink from './LegalDocumentLink'
import { getAnalyticsConsent, setAnalyticsConsent, subscribeCookieSettings, useAnalyticsConsent } from '../lib/analyticsConsent'
import './CookieNotice.css'

// Analytics has its own optional choice, independent of sign-in and the account's consent.
export default function CookieNotice() {
  const consent = useAnalyticsConsent()
  const [editing, setEditing] = useState(false)
  const [settingsOpen, setSettingsOpen] = useState(false)
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true)
  const analyticsInput = useRef<HTMLInputElement>(null)

  useEffect(() => subscribeCookieSettings(() => {
    setAnalyticsEnabled(getAnalyticsConsent() !== 'denied')
    setEditing(true)
    setSettingsOpen(true)
  }), [])

  useEffect(() => {
    if (settingsOpen) analyticsInput.current?.focus()
  }, [settingsOpen])

  if (consent !== null && !editing) return null

  const choose = (allowed: boolean) => {
    setAnalyticsConsent(allowed ? 'granted' : 'denied')
    setEditing(false)
    setSettingsOpen(false)
  }

  return (
    <section className={`cookie-notice${settingsOpen ? ' cookie-notice--settings' : ''}`} aria-label="Уведомление об использовании cookie">
      {settingsOpen ? (
        <form className="cookie-notice__settings" onSubmit={(event) => {
          event.preventDefault()
          choose(analyticsEnabled)
        }}>
          <h2 className="cookie-notice__title">Настройки cookies</h2>
          <label className="cookie-notice__option">
            <span className="cookie-notice__option-text">
              <span id="cookie-necessary-label" className="cookie-notice__option-name">Необходимые</span>
              <span id="cookie-necessary-description" className="cookie-notice__hint">Нужны для работы сервиса</span>
            </span>
            <span className="cookie-notice__switch">
              <input type="checkbox" role="switch" aria-labelledby="cookie-necessary-label" aria-describedby="cookie-necessary-description" checked disabled />
              <span className="cookie-notice__switch-track" aria-hidden="true" />
            </span>
          </label>
          <label className="cookie-notice__option">
            <span className="cookie-notice__option-text">
              <span id="cookie-analytics-label" className="cookie-notice__option-name">Аналитика</span>
              <span id="cookie-analytics-description" className="cookie-notice__hint">Помогает нам улучшать Lupa</span>
            </span>
            <span className="cookie-notice__switch">
              <input ref={analyticsInput} type="checkbox" role="switch" aria-labelledby="cookie-analytics-label" aria-describedby="cookie-analytics-description" checked={analyticsEnabled} onChange={(event) => setAnalyticsEnabled(event.target.checked)} />
              <span className="cookie-notice__switch-track" aria-hidden="true" />
            </span>
          </label>
          <div className="cookie-notice__actions">
            <button type="button" className="cookie-notice__configure cookie-notice__back" onClick={() => {
              setAnalyticsEnabled(consent !== 'denied')
              setSettingsOpen(false)
            }}>Назад</button>
            <button type="submit" className="cookie-notice__btn">Сохранить настройки</button>
          </div>
        </form>
      ) : (
        <>
          <div className="cookie-notice__text">
            <h2 className="cookie-notice__title">Мы используем cookies</h2>
            <p>
              Они нужны для работы Lupa и аналитики. Нажимая «Принять», вы соглашаетесь
              с их использованием в соответствии с{' '}
              <LegalDocumentLink to="/legal/privacy">Политикой обработки персональных данных</LegalDocumentLink>.
            </p>
          </div>
          <div className="cookie-notice__actions cookie-notice__actions--banner">
            <button type="button" className="cookie-notice__btn" onClick={() => choose(true)}>Принять</button>
            <button type="button" className="cookie-notice__configure" onClick={() => {
              setAnalyticsEnabled(consent !== 'denied')
              setSettingsOpen(true)
            }}>Настроить</button>
          </div>
        </>
      )}
    </section>
  )
}
